import ApiService from "service/Api";

const MemberService = {
  getAllMembers: async (
    page: number,
    search: string,
    limit: number,
    filterTenant: number,
    filterTier: string,
    filterPortal: string,
    filterBlacklist: string = ""
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_tenant: filterTenant,
        filter_tier: filterTier,
        filter_portal: filterPortal,
        is_blacklist_raffle: filterBlacklist,
      },
      url: "admin/members",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getMemberPointActivities: async (memberId: number) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "admin/members/point-activities/" + memberId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeVerifyKTP: async (userId: string, verifyKTP: boolean) => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        user_id: userId,
        is_ktp_verified: verifyKTP,
      },
      url: "admin/members/verify-ktp",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeRaffleBlacklist: async (userId: string) => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      data: {
        id: userId,
      },
      url: "admin/members/user-raffle-blacklist",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default MemberService;
